<template>
  <div class="likes">
    <ShareNetwork
      :url="url"
      :title="title"
      :description="description"
      :network="network.name"
      class="likes__link"
      v-for="network in networks"
      :key="network.name"
    >
      <Icon :name="network.icon" class="likes__icon" :title="network.label" />
    </ShareNetwork>
  </div>
</template>

<script>
  export default {
    data () {
      const description = document.querySelector('meta[name=description]').getAttribute('content')
      return {
        url: window.location.href,
        title: document.title,
        description,
        networks: [
          {
            icon: 'vkontakte',
            label: 'Поделиться Вконтакте',
            name: 'vk',
          },
          {
            icon: 'facebook',
            label: 'Поделиться на Facebook',
            name: 'facebook',
          },
          {
            icon: 'telegram',
            label: 'Поделиться в Telegram',
            name: 'telegram',
          },
          {
            icon: 'twitter',
            label: 'Твитнуть',
            name: 'twitter',
          },
        ]
      }
    }
  }
</script>

<style lang="scss">
  .likes {
  }

  .likes__link {
    display: inline-block;
    vertical-align: top;
    transition: 0.15s color;
    padding: 5px;
    &:hover {
      color: $color-cyan;
    }
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }

  .likes__icon {
    display: block;
  }
</style>
